var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableHousePricing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 14 16 2 31 14",
    fill: "none",
    stroke: "#a805fb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-cap": "butt",
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 16 5 30 27 30 27 16",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 24 14 19 17 22 22 17",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-color": "color-2",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18 15 24 15 24 21 18 15",
    fill: "#a805fb",
    "data-cap": "butt",
    "data-color": "color-2",
    "data-stroke": "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHousePricing);
export default __webpack_public_path__ + "static/media/Table-House-Pricing.a6519b3623fd23d170f3c65e312aa8cc.svg";
export { ForwardRef as ReactComponent };